import { render, staticRenderFns } from "./addRecordDialog.vue?vue&type=template&id=4bc6f84e&scoped=true&"
import script from "./addRecordDialog.vue?vue&type=script&lang=js&"
export * from "./addRecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./addRecordDialog.vue?vue&type=style&index=0&id=4bc6f84e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc6f84e",
  null
  
)

export default component.exports